export default __webpack_public_path__ + "static/media/Belt of the Tormentor.db15c90e.jpg";